import React from "react"
import HTMLReactParser from "html-react-parser"
// import { FeaturedBlock } from "components/FeaturedBlock"
import { Staff } from "components/Teaser"
import { ImgRow } from "components/ImgRow"

// Staff Block
const getStaff = attribs => {
  const data = JSON.parse(attribs.items)
  console.log(data)
  return <Staff data={data} />
}

const getImageRow = attribs => {
  console.log(attribs)
  return <ImgRow images={attribs} />
}

// Parse Custom Blocks
export function parseBlockContent(markup) {
  const Content = HTMLReactParser(markup, {
    replace: ({ attribs }) => {
      if (!attribs) return

      if (attribs.class && attribs.class.includes("acf-block--staff")) {
        return getStaff(attribs)
      }
      
      if (attribs.class && attribs.class.includes("acf-block--imagerow")) {
        return getImageRow(attribs)
      }
    },
  })

  return Content
}
